import consumer from './consumer';

document.addEventListener('DOMContentLoaded', () => {
  const TIMEOUT_DELAY_IN_MS = 5000;

  if (!$('#subscriptionIntentionId').length) {
    return;
  }

  consumer.subscriptions.create(
    {
      channel: 'SubscriptionIntentionChannel',
      subscription_intention_id: $('#subscriptionIntentionId').data('id'),
    },
    {
      received(data) {
        try {
          if (data.status === 'success') {
            setTimeout(() => {
              window.location.href = data.next_step_path;
            }, TIMEOUT_DELAY_IN_MS);
          } else if (data.status === 'failure') {
            setTimeout(() => {
              $('#subscriptionStep1').addClass('d-none');
              $('#subscriptionStep1Failure').removeClass('d-none');
            }, TIMEOUT_DELAY_IN_MS);
          } else {
            setTimeout(() => {
              $('#subscriptionStep1').addClass('d-none');
              $('#subscriptionStep1Error').removeClass('d-none');
            }, TIMEOUT_DELAY_IN_MS);
          }
        } catch {
          setTimeout(() => {
            $('#subscriptionStep1').addClass('d-none');
            $('#subscriptionStep1Error').removeClass('d-none');
          }, TIMEOUT_DELAY_IN_MS);
        }
      },
      rejected() {
        setTimeout(() => {
          $('#subscriptionStep1').addClass('d-none');
          $('#subscriptionStep1Error').removeClass('d-none');
        }, TIMEOUT_DELAY_IN_MS);
        this.uninstall();
      },
    }
  );
});
